import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable'
import { authRoles } from '../../auth/authRoles'

const PhotoToXML = Loadable(lazy(() => import('./PhotoToXML')))

const AnalyticsRoutes = [
    {
        path: '/convert-invoice',
        element: <PhotoToXML />,
        auth: authRoles.admin,
    },
]

export default AnalyticsRoutes
